import { Image, Statistic, Row, Col } from 'antd';
import { history } from 'umi';
import { useIntl } from 'react-intl';
import { Typography, Button } from 'iglooform';
import { images } from '@/assets/images';
import moment from 'moment';
import './index.less';

interface IWithdrawalSuccessfulProps {
  resultData: IWithdrawalSuccessful;
}

const WithdrawalSuccessfulPage = ({
  resultData,
}: IWithdrawalSuccessfulProps) => {
  const currentLang = localStorage.getItem('select_lang');
  const { formatMessage } = useIntl();
  return (
    <Row className="cashout-container">
      <Col span={12} className="content">
        <section className="success-icon">
          <Image
            src={images.success_icon}
            className="image"
            alt="successful"
            preview={false}
          />
        </section>
        <section className="notice">
          <Typography level="h2" className="title">
            {formatMessage({ id: 'A request has been sent to cash out' })}.
          </Typography>
          <Typography level="body1" className="sub-notice">
            {formatMessage({
              id: 'Your withdrawal request will be processed within',
            })}{' '}
            <Typography
              level="body1"
              style={{ color: '#212121', fontWeight: 700 }}
            >
              {formatMessage({ id: '1 working day' })}
            </Typography>
            .
          </Typography>
        </section>
        <section className="result-card">
          <Typography level="body2" className="date">
            {moment(resultData.requested_time * 1000).format('lll')}
          </Typography>
          <section className="amount-content">
            <section className="amount-list">
              <Typography level="body2">
                {formatMessage({ id: 'Reference No.' })}
              </Typography>
              <Typography level="body2">{resultData.reference_no}</Typography>
            </section>
            <section className="amount-list">
              <Typography level="body2">
                {formatMessage({ id: 'Request Amount' })}
              </Typography>
              <Statistic
                style={{ display: 'inline-block' }}
                value={resultData.amount}
                suffix={formatMessage({ id: 'VND' })}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
                className="statistic"
              />
            </section>
            <section className="amount-list">
              <Typography level="body2">
                {/* {(Number(resultData.tax_amount) / Number(resultData.amount)) *
                  100} */}
                {formatMessage({ id: '10% Income Tax' })}
              </Typography>
              <Statistic
                style={{ display: 'inline-block' }}
                value={resultData.tax_amount}
                suffix={formatMessage({ id: 'VND' })}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
                className="statistic"
              />
            </section>
            <section className="amount-list">
              <Typography
                level="body2"
                style={{ color: '#5A5A5A', fontWeight: 700 }}
              >
                {formatMessage({ id: 'Net Cash out Amount' })}
              </Typography>
              <Statistic
                style={{ display: 'inline-block' }}
                value={resultData.actual_amount}
                suffix={formatMessage({ id: 'VND' })}
                valueStyle={{ color: '#5A5A5A', fontWeight: 700 }}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
                className="statistic"
              />
            </section>
          </section>
        </section>
        <Button
          type="default"
          style={{ marginTop: '24px' }}
          onClick={() => history.push('/earnings')}
          block
        >
          {formatMessage({ id: 'Back to Earnings' })}
        </Button>
        <section style={{ marginTop: '8px' }}>
          <Typography level="body2" style={{ color: '#666' }}>
            {formatMessage({ id: 'Please contact us at' })}{' '}
            <a href="mailto:cs.vn@iglooinsure.com">cs.vn@iglooinsure.com </a>
            {formatMessage({ id: 'for any enquires' })}.
          </Typography>
        </section>
      </Col>
    </Row>
  );
};

export default WithdrawalSuccessfulPage;
